(function () {
  if (window.__motionA11yInit) { return; }
  window.__motionA11yInit = true;

  var $ = jQuery;
  $(document).ready(function () {
    setTimeout(function () {
      $(".jdgm-widget .jdgm-prev-badge__stars").attr("role", "img");
      $("b.jdgm-rev__title").replaceWith(function () {
        return $("<strong />", {
          html: $(this).html(),
          class: $(this).attr("class"),
        });
      });
    }, 1000);
    console.log("ready");
  });

  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  const debouncedOnDomChange = debounce(function () {
    $(
      ".testimonials-slide[aria-hidden], .product-main-slide[aria-hidden]"
    ).removeAttr("aria-hidden");

    var focusableSel = "a[href], button, input, select, textarea, iframe, [tabindex], [contenteditable='true']";
    document
      .querySelectorAll('[aria-hidden="true"]:not(.pswp):not([role="dialog"]):not([aria-modal="true"]):not(.slideshow__slide)')
      .forEach(function (el) {
        if (el.hasAttribute("inert")) return;
        if (el.querySelector(focusableSel)) {
          el.setAttribute("inert", "");
          el.setAttribute("data-a11y-inert", "1");
        }
      });
    document.querySelectorAll("[data-a11y-inert]").forEach(function (el) {
      if (el.getAttribute("aria-hidden") !== "true") {
        el.removeAttribute("inert");
        el.removeAttribute("data-a11y-inert");
      }
    });

    document.querySelectorAll('[id=""]').forEach(function (el) {
      el.removeAttribute("id");
    });
    $(".additional-checkout-buttons").each(function () {
      var ulElement = $(this).find("ul");

      if (ulElement.length > 0 && ulElement.children().length === 0) {
        ulElement.remove();
      }
    });

    var iframeIdx = 0;
    $("iframe").each(function () {
      var $f = $(this);
      var src = $.trim($f.attr("src") || "");

      if (!src || src === "about:blank") {
        $f.attr("aria-hidden", "true").attr("tabindex", "-1");
        if (!$f.attr("title")) $f.attr("title", "");
        return;
      }

      if (!this.hasAttribute("title") || $f.attr("title") === "") {
        var derived = $f.attr("name") || $f.attr("id") || $f.attr("aria-label");
        if (!derived) {
          iframeIdx++;
          derived = "Embedded content " + iframeIdx;
        }
        $f.attr("title", derived);
      }
    });

    $('a[href="#looxReviewsFrame"], a[href^="#loox"], a[href^="#lox"], a.loox-rating, a:has(.loox-rating)').each(function () {
      var $a = $(this);
      if ($.trim($a.attr("aria-label") || "")) return;
      var txt = $.trim($a.text());
      if (txt) return;
      var label = "";
      var $rating = $a.find("[data-rating], .loox-rating").addBack("[data-rating], .loox-rating").first();
      var rating = $rating.attr("data-rating");
      var raters = $a.find("[data-raters]").attr("data-raters") || $rating.attr("data-raters");
      if (rating) {
        label = rating + " star rating";
        if (raters) label += " from " + raters + " reviews";
        label += ", read reviews";
      }
      if (!label) {
        var imgAlt = $a.find("img[alt]").attr("alt");
        label = imgAlt && $.trim(imgAlt) ? $.trim(imgAlt) : "Read customer reviews";
      }
      $a.attr("aria-label", label);
    });

    $('a[target="_blank"]:not([data-nw-a11y])').each(function () {
      var $a = $(this);
      $a.attr("data-nw-a11y", "1");
      var existingLabel = ($a.attr("aria-label") || "").toLowerCase();
      var existingTitle = ($a.attr("title") || "").toLowerCase();
      var hasWarning = existingLabel.indexOf("new window") !== -1 ||
        existingLabel.indexOf("new tab") !== -1 ||
        existingTitle.indexOf("new window") !== -1 ||
        existingTitle.indexOf("new tab") !== -1 ||
        $a.find('.a11y-newwin-hint').length > 0;
      if (hasWarning) return;
      $a.append(' <span class="visually-hidden a11y-newwin-hint">(opens in new window)</span>');
    });
  }, 500);
  const observer = new MutationObserver((mutations) => {
    debouncedOnDomChange();
  });
  const config = {
    childList: true,
    subtree: true,
    attributes: true,
  };

  observer.observe(document.body, config);

  $(window).on("load", function () {
    setTimeout(function () {
      var i = 1;
      $("#web-pixels-manager-sandbox-container iframe").each(function () {
        $(this).attr("title", "web pixels iframe" + " " + i);
        i++;
      });
      debouncedOnDomChange();
    }, 2000);

    console.log("load");
  });

})(); 
